import Head from 'next/head';
{/* <Head><title>해시태그 | 캠스콘 CAMSCON</title></Head> */ }

export default props => {
    // console.log(": ", props.subject);
    return (
    // <div className="">
        <Head><title>
            {props.subject ? props.subject+" | ":""}
            {/* 해시태그 |  */}
            {process.browser && location.href.indexOf("localhost") > 1 ? props.subject : "캠스콘 CAMSCON"}
            
        </title></Head>
    // </div>
    );
}